/* eslint-disable arrow-body-style */
import Vue from 'vue';

export default {
  getUserTabs() {
    return Vue.axios.get('/auth/user').catch((error) => {
      // If user is not logged in yet (e.g. right after register), API returns 401.
      // That is expected, so don't bubble it up as a "network error" toast.
      if (error.response && error.response.status === 401) {
        return null;
      }
      throw error;
    });
  },
  createUserTab(payload) {
    return Vue.axios.post('/user-tabs', payload).catch((error) => {
      throw new Error(`${error}`);
    });
  },
  updateUserTab(payload) {
    return Vue.axios.put(`/user-tabs/${payload.tabId}`, payload).catch((error) => {
      throw new Error(`${error}`);
    });
  },
  deleteUserTab(payload) {
    return Vue.axios.delete(`/user-tabs/${payload}`).catch((error) => {
      throw new Error(`${error}`);
    });
  },
};
